import type { DrawerProps } from 'antd';
import { Drawer } from 'antd';
import React from 'react';

import { useIsMobileL } from '../hooks/useBreakpoint';

interface Props extends DrawerProps {
	className?: string;
}

const SimpleDrawer: React.FC<Props> = ({ open, title, children, onClose, ...rest }) => {
	const isMobile = useIsMobileL();
	return (
		<Drawer {...rest} title={title} onClose={onClose} open={open} width={isMobile ? window.innerWidth : undefined}>
			{children}
		</Drawer>
	);
};

export default SimpleDrawer;
